module.exports = __webpack_public_path__ + "static/media/fleetdriverIcon.dc8228fa.svg";